import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { GerenciarDownloadArquivoService } from '../../service/gerenciar-download-arquivo.service';
import { GerenciarDownloadArquivo } from '../../api/dto/gerenciar-download-arquivo';
import { DownloadArquivoService } from '../../service/download-arquivo.service';
import { ErroService } from '../../service/erro.service';

@Component({
  selector: 'app-download-arquivo',
  templateUrl: './download-arquivo.component.html',
  styleUrls: ['./download-arquivo.component.scss']
})
export class DownloadArquivoComponent implements OnInit {

  id?: string;
  mensagemErro: Message[] = [];
  mensagemErroVisivel: boolean = false;
  download?: GerenciarDownloadArquivo;
  
  loadingSpinner: boolean = true;
  progressoRequisicao: boolean = false;

  constructor(private gerenciarDownloadAquivoService: GerenciarDownloadArquivoService,
    private downloadService: DownloadArquivoService,
    private layoutService: LayoutService,
    private erroService: ErroService,
    private _router: Router,
    private activatedRouter: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.carregarId();
    this.carregarArquivo();
  }

  carregarId() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = idParam;
    }
  }

  carregarArquivo() {
    this.gerenciarDownloadAquivoService.buscarPorId(this.id).subscribe({
      next: (data: GerenciarDownloadArquivo) => {
        this.download = data;
        this.loadingSpinner = false;
      },
      error: (err: any) => {
        this.mensagemErro = this.erroService.handleErro(err);
        this.mensagemErroVisivel = true;
        this.loadingSpinner = false;

      }
    }
    )
  }

  get dark(): boolean {
    return this.layoutService.config.colorScheme !== 'dark';
  }

  baixarArquivo() {
    this.progressoRequisicao = true;
    const url = this.download?.endpoint ?? '';
    this.downloadService.baixar(url, this.download?.accessToken).subscribe({
      next: (data: Blob) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `extrato-conta-${this.download?.nomeArquivo}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.progressoRequisicao = false;
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.mensagemErro = this.erroService.handleErro(err);
        this.mensagemErroVisivel = true;
      }
    })
  }

}
